import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormsModule, ValidationErrors } from '@angular/forms';
import { AnnotationsRoutingModule } from 'src/app/features/annotations/annotations-routing.module';
import { EditorSaveService } from 'src/app/features/custom-texts/services/custom-text-selection.service';
import { MaterialModule } from '../../material.module';
import { AutofillItem, AutoFillSelectOptions } from './interface';

@Component({
  selector: 'app-editor',
  templateUrl: './app-editor.component.html',
  styleUrls: ['./app-editor.component.scss'],
  standalone: true, // Required for imports
  imports: [
    CommonModule,
    FormsModule,
    MaterialModule,
    AnnotationsRoutingModule,
  ],
})
export class AppEditorComponent implements OnChanges {
  @Input() customClass: string = '';
  @Input() errors: ValidationErrors | null = null;
  @Input() disabled: boolean = false;
  @Input() maxLength: number = 0;
  @Input() autofillOptions: AutoFillSelectOptions = [];
  @Input() label: string = '';
  @Input() placeholder: string = 'comments';
  @Input() currentLang?: 'en' | 'he' = undefined;
  @Input() content: string = ''; // Bind content from parent
  @Output() contentChange = new EventEmitter<string>(); // Emit changes
  @Input() group: string | null = null;
  @Output() generateTextClick = new EventEmitter<AutofillItem>();
  @Output() onChangeLang = new EventEmitter<string>();
  selectedAutoFill?: AutofillItem;
  contentLength = 0;
  isEmptyArrayProvided: boolean = false
  constructor(private editorSaveService: EditorSaveService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['content']) {
      this.contentLength = this.content?.length || 0;
    }
    const autofillChange = changes['autofillOptions'];
    if (autofillChange) {
      const parentProvidedValue = autofillChange.currentValue;

      // Check if parent provided empty array
      this.isEmptyArrayProvided =
        Array.isArray(parentProvidedValue) && parentProvidedValue.length === 0;

      if (!this.selectedAutoFill && !this.isEmptyArrayProvided) {
        this.selectedAutoFill = parentProvidedValue[0];
      }
    }
  }

  onContentChange(newContent: string) {
    this.contentChange.emit(newContent); // Notify parent of changes
  }

  setLang(option: 'en' | 'he') {
    this.onChangeLang.emit(option);
  }

  onMenuOptionSelected(item: any): void {
    this.selectedAutoFill = item;
  }

  hasError(type: string): boolean {
  return this.errors?.[type];
}

onKeyDown(event: KeyboardEvent, textarea: HTMLTextAreaElement): void {

  if(!this.group) {return}
  if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === 's') {
    event.preventDefault();

    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;

    if (start !== end) {
      const selectedText = textarea.value.substring(start, end).trim();

      if (selectedText) {
        console.log('Editor: requested save', this.group, selectedText)
        this.editorSaveService.requestSave(this.group, selectedText);
      }
    }
  }
}


  generateText() {
    this.generateTextClick.emit(this.selectedAutoFill);
  }
  trackByLabel = (index: number, item: AutofillItem) => item.name;
}
